import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormControl } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';

import { updateLeadFields } from 'bundles/project/actions/leads';
import SaveMessage from 'bundles/project/components/leads/show/save_message';
import { formatDateTime } from 'helpers/formatters/date_time_formats';

const SAVE_MESSAGE_TIMEOUT = 3000;

export class ClientReportNotes extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    lead: PropTypes.shape({
      noteToClient: PropTypes.shape({
        body: PropTypes.string,
        updatedAt: PropTypes.string
      }).isRequired
    }).isRequired,
    onUpdateField: PropTypes.func.isRequired
  };

  state = {
    editing: false,
    noteBody: this.props.lead.noteToClient.body
  };

  constructor(props) {
    super(props);
    this.noteInput = null;
  }

  componentWillUnmount() {
    this.resetMessageTimeout();
  }

  componentDidUpdate(prevState) {
    if (this.state.editing && !prevState.editing && this.noteInput) this.noteInput.focus();
  }

  canSave = () => this.state.editing && !this.state.saving && this.props.lead.noteToClient.body !== this.state.noteBody;

  startEdit = (e) => {
    e.preventDefault();
    if (this.state.editing) return;

    this.setState({ editing: true });
  };

  handleCancel = () => {
    this.setState({ editing: false });
    this.setState({ noteBody: this.props.lead.noteToClient.body });
  };

  handleChange = (e) => {
    this.setState({ noteBody: e.target.value });
  };

  handleSave = (e) => {
    e.preventDefault();

    if (!this.canSave()) return;

    this.setState({ saving: true });

    const { lead, onUpdateField } = this.props;
    const payload = { noteToClientAttributes: { body: this.state.noteBody } };
    onUpdateField(lead, payload).then(() => {
      this.setState({
        editing: false,
        saving: false,
        saveMessage: { type: 'success', text: 'Notes saved successfully' }
      });
      this.setMessageTimeout();
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      this.setState({
        saving: false,
        saveMessage: { type: 'error', text: 'An error occurred when saving your notes.  Try again shortly.' }
      });
      this.setMessageTimeout();
    });
  };

  resetMessageTimeout = () => {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
      this.messageTimeout = null;
    }
  };

  setMessageTimeout = () => {
    this.resetMessageTimeout();
    setTimeout(() => {
      this.messageTimeout = null;
      this.setState({ saveMessage: undefined });
    }, SAVE_MESSAGE_TIMEOUT);
  };

  renderCard() {
    const { updatedAt } = this.props.lead.noteToClient;
    const oldMessage =
      'Click "Edit Note" button to enter any notes about this Lead that you would like to share via the Client Report.';
    const newMessage = 'Click to enter any notes about this Lead that you would like to share via the Client Report.';

    if (this.state.noteBody) {
      return (
        <div className="card border p-3" role="button">
          <div className="card-body" name="notes-body-card" style={{ whiteSpace: 'pre' }}>
            {this.state.noteBody}
          </div>
          <div className="card-footer text-muted mt-2">
            <small>Last edited { formatDateTime(updatedAt) }</small>
          </div>
        </div>
      );
    }

    return (
      <div
        className="text-muted pl-2 pt-2 border-top"
        name="empty-state"
        role="button"
      >
        {newMessage}
      </div>
    );
  }

  renderTextarea() {
    return (
      <FormControl
        componentClass="textarea"
        inputRef={ref => this.noteInput = ref}
        name="client-report-notes-body"
        value={this.state.noteBody}
        onChange={this.handleChange}
      />
    );
  }

  render() {
    const { className } = this.props;
    const { editing, saveMessage, saving } = this.state;

    return (
      <div className={className}>
        {this.renderHeader()}
        <form
          name="lead-client-report-notes-form"
          onClick={this.startEdit}
          onSubmit={this.handleSave}
        >
          {editing ? this.renderTextarea() : this.renderCard()}
          <div className="mt-2">
            <SaveMessage message={saveMessage} />
          </div>
          <div className={`row mt-2 mb-2 ${(editing ? 'visible' : 'invisible')}`}>
            <div className="col-xs-12 col-sm-6 pull-right text-right">
              <button
                className="btn btn-cancel"
                name="cancel-note-update-button"
                type="button"
                onClick={this.handleCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn-save left-buffer-sm"
                disabled={!this.canSave()}
                type="submit"
                onClick={this.handleSave}
              >
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderEditNoteLink() {
    if (this.state.editing) return;

    return (
      <button
        className="btn btn-link p-0"
        name="edit-note-button"
        onClick={this.startEdit}
      >
        <FontAwesomeIcon icon={faPencil} />
        <span className="left-buffer-sm">Edit Note</span>
      </button>
    );
  }

  renderHeader() {
    return (
      <div>
        <label>Notes</label>
      </div>
    );
  }
}

const mapDispatchToProps = {
  onUpdateField: updateLeadFields
};

export default connect(null, mapDispatchToProps)(ClientReportNotes);
